<template>
    <router-link to="/">
        <img class="for-light" style="width: 190px; margin-left: -25px; padding-top: 4px;" src="../../assets/images/logo/logo.png" alt="" /><img class="for-dark" style="width: 190px; margin-left: -25px; padding-top: 4px;" src="../../assets/images/logo/logo.png" alt="" />
    </router-link>
</template>

<script>
export default {
    name: 'Logo',
};
</script>
